import { useNavigate } from 'react-router-dom';
import { useGlobalContext } from '~/context/GlobalContext';
import { useAuth } from '~/hooks/useAuth';
import styles from '~/styles/AdminPanel/AdminPanel.module.css';

function ModeratorPanel() {
  const { context } = useGlobalContext();
  const { joinRoom } = useAuth();
  const navigate = useNavigate();

  const role = context.authUser?.role;
  const canAccess = role === 'moderator' || role === 'administrator';

  const goBackToChat = async () => {
    if (context.authUser) {
      const joined = await joinRoom(context.authUser);
      if (joined) return;
    }
    navigate('/');
  };

  if (!canAccess) {
    return (
      <div className={styles.accessDenied}>
        <svg width="48" height="48" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.5">
          <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z" />
        </svg>
        <h2>Brak dostępu</h2>
        <p>Ta strona jest dostępna tylko dla moderatorów i administratorów.</p>
        <button className={styles.refreshBtn} onClick={() => navigate('/')}>Wróć na stronę główną</button>
      </div>
    );
  }

  return (
    <div className={styles.pageWrapper}>
      <div className={styles.topBar}>
        <button className={styles.backBtn} onClick={goBackToChat} title="Wróć do czatu">
          ←
        </button>
        <span className={styles.topBarTitle}>Panel Moderatora</span>
      </div>

      <div className={styles.dashGrid}>
        <div className={styles.dashCard} onClick={() => navigate('/users')}>
          <svg width="32" height="32" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.5">
            <path strokeLinecap="round" strokeLinejoin="round" d="M15 19.128a9.38 9.38 0 002.625.372 9.337 9.337 0 004.121-.952 4.125 4.125 0 00-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 018.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0111.964-3.07M12 6.375a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zm8.25 2.25a2.625 2.625 0 11-5.25 0 2.625 2.625 0 015.25 0z" />
          </svg>
          <h3>Użytkownicy</h3>
          <p>Lista moderatorów i użytkowników z akcjami moderatora</p>
        </div>
      </div>
    </div>
  );
}

export default ModeratorPanel;
